export default __webpack_public_path__ + "static/prostatizal-cfa2c42528d9ed7118f80ba6da46d7f2.jpg";